import { VehicleFeature } from '@/catalog/types/vehicle';
import { getAllowedCategories } from '@/common/utils/category-mappings';
import { useGroupedFeatures } from '@/common/hooks/use-grouped-features';
import SpecificationGroup from './specification-group';
import { DrawerDialog } from '@/common/components/drawer-dialog';
import { Button } from '@/shadcn-ui/button';

interface SpecificationsProps {
  featuresSpecs: VehicleFeature[];
  sortAscending?: boolean;
}

export default function Specifications({
  featuresSpecs,
  sortAscending = false,
}: SpecificationsProps) {
  const allowedCategories = getAllowedCategories('specifications');

  const groupedSpecifications = useGroupedFeatures(
    featuresSpecs,
    allowedCategories,
    sortAscending,
    'specifications'
  );

  if (!Object.keys(groupedSpecifications).length) return null;

  return (
    <div className="flex w-full flex-col items-start justify-between gap-[24px] rounded-[24px] bg-flexcar-neutral100 p-6 md:gap-[48px] md:rounded-[32px] md:p-12 xl:flex-row">
      <SpecificationGroup groupedSpecifications={groupedSpecifications} />

      {/* "View All" Button (Only visible on mobile view) */}
      <div className="flex w-full justify-center md:hidden">
        <DrawerDialog
          trigger={
            <Button
              variant="primary"
              className="focus:ring-none hover:ring-none ring-none active:ring-none focus:ring-none button1-tight flex w-full items-center rounded-full border-[1px] border-flexcar-neutral70 bg-flexcar-neutral100 px-[48px] py-[14px] font-medium text-flexcar-neutral1 shadow-none ring-flexcar-neutral100 hover:bg-flexcar-neutral100 focus:bg-flexcar-neutral100 focus:shadow-none active:bg-flexcar-neutral100 active:shadow-none"
            >
              View all
            </Button>
          }
        >
          {/* Feature Group for Dialog */}
          <SpecificationGroup
            groupedSpecifications={groupedSpecifications}
            isFullSpecificationListView={true}
          />
        </DrawerDialog>
      </div>
    </div>
  );
}
